// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federcharakteristik/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federcharakteristikDE: PageEntry = {
  id: "post.federcharakteristik",
  locale: "de",
  slug: "federcharakteristik",
  seo: {
    title: "Glossar: Federcharakteristik einfach erklärt | Dietz GmbH",
    description: "Die Federcharakteristik beschreibt die spezifischen mechanischen Eigenschaften einer Feder, die ihre Reaktion auf äußere Belastungen bestimmen. Dazu gehören Parameter wie Federkons",
  },
  type: "post",
  h1: "Glossar: Federcharakteristik einfach erklärt",
  intro: "Die Federcharakteristik beschreibt die spezifischen mechanischen Eigenschaften einer Feder, die ihre Reaktion auf äußere Belastungen bestimmen. Dazu gehören Parameter wie Federkonstante, Federsteifigkeit, Federbelastungsgrenze und Dämpfung. Die Charakteristik einer Feder beeinflusst ihre Einsatzmöglichkeiten in verschiedenen Anwendungen. Eine Feder mit einer steifen Charakteristik eignet sich beispielsweise für Anwendungen, die hohe Kräfte erfordern, während eine weichere Charakteristik für Anwendungen mit geringeren Belastungen geeignet ist. Die genaue Kenntnis der Federcharakteristik ist entscheidend für die Auswahl und Auslegung von Federn in technischen Systemen.",
  blocks: [

  ],
};
